import * as React from 'react';
import { inject, observer } from 'mobx-react';

// Constants
import { ROUTE_PATHS } from '../../constants/routes';

// Types
import { IStore } from '../../store/Store';

// Components
import Box from '../../components/Box';
import { CircularProgress } from '../../components/Progress';

// Component
interface IProps {
  store?: IStore;
}

class Redirecter extends React.Component<IProps, {}> {
  componentDidMount() {
    this.redirect();
  }

  componentWillReceiveProps() {
    this.redirect();
  }

  redirect() {
    if (this.props.store!.meStore.user !== null) {
      const meStore = this.props.store!.meStore;
      const networkId = meStore.user!.lastNetworkId
        ? meStore.user!.lastNetworkId
        : meStore.networks![0] ? meStore.networks![0].networkId : null;

      if (networkId === null) {
        this.props.store!.routerStore.navigate(
          ROUTE_PATHS.APP_INTRO,
          {},
          { replace: true }
        );
      } else {
        this.props.store!.routerStore.navigate(
          ROUTE_PATHS.APP_NETWORK,
          { networkId },
          { replace: true }
        );
      }
    }
  }

  render() {
    return (
      <Box mt={5} align="center">
        <CircularProgress />
      </Box>
    );
  }
}

export default inject('store')(observer(Redirecter));



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/App/Redirecter.tsx